import { Toast } from '@byecode/ui'
import type { ErrorCode } from '@lighthouse/shared'
import { errorCodeMap, limitExceededCodeList } from '@lighthouse/shared'
import type { IsSuccessfulCall } from '@rpldy/shared'
import type { UploadyProps } from '@rpldy/shared-ui'

import { openSpaceGrade } from '@/components/SpaceGrade'
import { QuotaMessage } from '@/components/SpaceQuota/QuotaMessage'
import { ERROR_CODE_QUOTA_KEY_MAP } from '@/components/SpaceQuota/QuotaMessage/constants'
import http from '@/http'

export const isSuccessfulCallToToast: IsSuccessfulCall = xhr => {
    // 🔑 401 必须返回 false，让 item 进入 ERROR 状态，retry() 才能工作
    if (xhr.status === 401) {
        return false
    }

    // 🔑 uploadStatus: 0 通常表示网络错误或请求被取消
    if (xhr.status === 0) {
        return false
    }

    if (xhr.status === 200) {
        const res = JSON.parse(xhr.response)
        const { code } = res
        if (code === '0030000') {
            return false
        }

        if (Object.hasOwn(ERROR_CODE_QUOTA_KEY_MAP, code)) {
            QuotaMessage({
                type: ERROR_CODE_QUOTA_KEY_MAP[code]
            })
            return false
        }

        if (limitExceededCodeList.includes(code)) {
            Toast.error(`${errorCodeMap[code as ErrorCode]}，`, {
                linkText: '请升级版本',
                onLinkClick: () => openSpaceGrade('version_upgrade')
            })
            return false
        }
    }
    return true
}

/**
 * 获取上传时需要的额外 headers（除 Authorization 外）
 * Authorization 会在 useRequestPreSend 中动态注入
 */
export const getUploadExtraHeaders = () => {
    const headers = { ...http.defaults.headers.common }
    // 删除 Authorization，因为它会在 useRequestPreSend 中动态注入
    delete headers.Authorization
    return headers
}

/** 上传管理器使用 */
export const uploadManagerInAppParams = (): UploadyProps => {
    return {
        destination: {
            url: '/lighthouse/api/v1/oss/uploadInApp',
            headers: getUploadExtraHeaders() // 每次调用时获取最新 headers
        },
        isSuccessfulCall: isSuccessfulCallToToast
    }
}

// 上传到公共资源
export const uploadPublicParams = (params?: Record<string, unknown>): UploadyProps => {
    return {
        destination: {
            url: '/lighthouse/api/v1/oss/uploadPublicResource',
            headers: getUploadExtraHeaders(),
            params
        }
    }
}

export const uploadMiniProgramResourceParams = (params?: Record<string, unknown>): UploadyProps => {
    return {
        destination: {
            url: '/lighthouse/api/v1/oss/uploadInApp',
            headers: getUploadExtraHeaders(),
            params
        }
    }
}
